import initSpecialistsSection from "./sections/specialists";
import initServices from "./sections/services";
import bindDataActions from "./helpers/data-actions";
import loadFiles from "./helpers/load-files";
import initDropdownMenu from "./components/dropdown";
import initYMap from "./components/ymap";
import initCmsComponents from "./components/cms";
import initFastlinks, { fixFastlinksHeight } from "./components/fastlinks";
import fixColsContainer from "./components/colsContainer";
import initDraggable from "./components/draggable";
import fixServicesLinksHeight from "./components/services";
import initSearchWidget from "./components/searchWidget";

document.addEventListener("DOMContentLoaded", function () {
    switcher();
    initCmsComponents(switcher, onEvent);
    headerPlate();
    leftColPlate();
    welcomeSearchPlate($(".index-welcome-plate .plate-search"));
    checkboxHandlers();
    headerDropdownMenu();
    initFastlinks($(".index-welcome-fastlinks"));
    initFastlinks($(".index-departments-fastlinks"));
    servicesGallery($(".index-services-widget"));
    defineImagesOrientation($(".pub-stories-widget"));
    defineImagesOrientation($(".links-widget"));
    storiesPopupGallery();
    markReadStories();
    initScrollFading();
    checkScrollFading();
    pageSectionGallery();
    categoriesFilter();
    selectInit();
    selectHandlers();
    stickySidebar();
    stickyHeader();
    subservicesActiveMenu();
    appointmentAgreement();
    accordion();
    searchForm();
    publicOffer();
    formFloatingLabel($(".page-form"));
    formSearchField($(".page-form"));
    siteChat();
    statusesDocumentsForm();
    tabsInit();
    tabsPaginations();
    topButton();
    imageBlock();
    buildMunicipalities();
    informationModal();
    personalDataProcessingWidget();
    departmentDropdown();
    cabinetListDropdown();
    filesLoaderButton();
    formHandler();
    filterMobile();
    notifyButtonHandler();
    fixIndexFeedbackHeight();
    shareButtonClick();
    phoneContactsShow();

    initSpecialistsSection();
    initServices();
    bindDataActions();
    initDropdownMenu();
    initYMap();
    fixColsContainer();
    initDraggable();
    fixServicesLinksHeight();
    registerTrash();
    initSearchWidget();
});

$(window).resize(function () {
    checkScrollFading();
    fixIndexFeedbackHeight();
    fixServicesLinksHeight();
    fixFastlinksHeight($(".index-welcome-fastlinks"));
});

$(window).scroll(function () {
    checkScrollFading();
});

function switcher() {
    onEvent("click", "[data-switcher]", function (e, button) {
        const name = button.dataset.switcher;
        if (!name) {
            return null;
        }

        const matchParam = button.dataset.switcherMatch;
        if (matchParam == "strict" && !e.target.matches("[data-switcher]")) {
            return null;
        }

        let action = button.dataset.switcherAction || "toggle";

        executeAction(name, action);
    });

    function executeAction(name, action) {
        const contentList = document.querySelectorAll(
            '[data-switcher-content="' + name + '"]'
        );
        if (contentList.length) {
            for (const content of contentList) {
                action = executeItemAction(content, action);
            }
        }

        const switcherList = document.querySelectorAll(
            '[data-switcher="' + name + '"]'
        );
        if (switcherList) {
            for (const switcherItem of switcherList) {
                executeItemAction(switcherItem, action);
            }
        }
    }

    function executeItemAction(item, action) {
        switch (action) {
            case "enable":
                item.classList.add("switcher-enable");
                return "enable";
            case "disable":
                item.classList.remove("switcher-enable");
                return "disable";
            case "toggle":
                item.classList.toggle("switcher-enable");
                return item.matches(".switcher-enable") ? "enable" : "disable";
        }
    }

    switcher.executeAction = executeAction;
}

function onEvent(eventName, selector, callback) {
    document.addEventListener(eventName, function (e) {
        if (selector) {
            const elem = e.target.closest(selector);
            if (elem) {
                callback(e, elem);
            }
        } else {
            callback(e);
        }
    });
}

/* WELCOME SEARCH PLATE */

function welcomeSearchPlate(plate) {
    if (!plate.length) {
        return null;
    }

    const fastlinks = $(".index-welcome-fastlinks");

    plate.on("focus", ".search-input", function () {
        activateForm();
    });

    plate.on("click", ".search-cancel", function () {
        $(".search-input", plate).val("");
        disableForm();
    });

    plate.on("click", ".search-samples .sample-item", function () {
        $(".search-input", plate).val($(this).text());
        activateForm();
        $("form", plate).submit();
    });

    function activateForm() {
        plate.addClass("active");
        fastlinks.addClass("hidden");
    }

    function disableForm() {
        plate.removeClass("active");
        fastlinks.removeClass("hidden");
    }
}

/* CHECKBOX HANDLERS */

function checkboxHandlers() {
    $(document).on("change", ".js-checkbox input", function () {
        updateCheckboxState($(this));
    });

    $(".js-checkbox input").each(function () {
        updateCheckboxState($(this));
    });

    function updateCheckboxState(input) {
        if (input.is(":checked")) {
            input.closest(".js-checkbox").addClass("checked");
        } else {
            input.closest(".js-checkbox").removeClass("checked");
        }
    }
}

/* HEADER DROPDOWN MENU */

function headerDropdownMenu() {
    var menuButton = $("#header .button-menu");
    var dropdown = $("#header .header-dropdown-menu");
    if (!menuButton || !dropdown) {
        return null;
    }

    menuButton.on("click", function () {
        menuButton.toggleClass("open");
        if (menuButton.is(".open")) {
            dropdown.addClass("open");
            $("html").addClass("no-scroll");
        } else {
            dropdown.removeClass("open");
            $("html").removeClass("no-scroll");
        }
    });

    dropdown.on("click", ".menu-item button", function () {
        $(this).closest(".menu-item").toggleClass("open");
    });
}

/* SERVICES */

function servicesGallery(container) {
    var rails = $(".links-rails", container);

    if (!rails || !rails.length) {
        return null;
    }

    var contentWidth = rails[0].scrollWidth,
        containerWidth = rails.width();

    if (contentWidth <= containerWidth) {
        return null;
    }

    var linksBlockSample = $(".links-block:first", rails);
    var scrollWidth = linksBlockSample.outerWidth(true);

    container.on("click", ".button-next", function () {
        var pos = parseInt(rails.css("left"));
        if (contentWidth + pos > containerWidth) {
            rails.css("left", pos - scrollWidth + "px");
        }
    });

    container.on("click", ".button-prev", function () {
        var pos = parseInt(rails.css("left"));
        if (pos < 0) {
            rails.css("left", pos + scrollWidth + "px");
        }
    });
}

function categoriesFilter() {
    const servicesFilter = $(".services-categories-filter");
    const servicesItemContainer = $(
        ".applicants-category-item .category-check-item input"
    );
    filterHandler(servicesFilter, servicesItemContainer);
    renderListFilterTags(servicesFilter);

    const docsFilter = $(".docs-categories-filter");
    const docsItemContainer = $(
        ".docs-category-item .category-check-item input"
    );
    docsFilterHandler(docsFilter, docsItemContainer);

    const modalFilter = $(".categories-filter-modal");
    modalFilterHandler(modalFilter);

    const askFilter = $(".ask-categories-filter");
    const askItemContainer = $(".ask-category-item .category-check-item input");
    filterHandler(askFilter, askItemContainer);

    function filterHandler(filter, itemContainer) {
        if (filter.length) {
            filter.on("click", ".category-item .item-button", function () {
                $(this).closest(".category-item").toggleClass("collapse");
            });

            itemContainer.on("click", function () {
                refreshFilter(filter);
            });

            filter.on("click", ".filter-submit", function () {
                refreshFilter(filter);
            });

            filter.on(
                "click",
                ".category-item .item-button-modal",
                function () {
                    $(".categories-filter-modal").show();
                    renderModalFilterTags(modalFilter);
                }
            );

            $(".services-list-container").on(
                "click",
                ".filter-tag-item",
                function () {
                    removeFilterTag($(this), filter);
                    refreshFilter(filter);
                }
            );
        }
    }

    function modalFilterHandler(filter) {
        if (filter.length) {
            filter.on("click", ".category-item .item-button", function () {
                $(this).closest(".category-item").toggleClass("collapse");
            });

            filter.on(
                "click",
                ".filter-modal-container .modal-close",
                function () {
                    $(this).closest(".categories-filter-modal").fadeOut("fast");
                }
            );

            filter.on(
                "click",
                ".filter-modal-container .modal-apply",
                function () {
                    refreshFilter(filter);
                    $(this).closest(".categories-filter-modal").fadeOut("fast");
                }
            );

            filter.change(() => {
                renderModalFilterTags(filter);
            });

            $(".modal-filters .category-check-item label").on(
                "click",
                function () {
                    $(this).prev(".js-checkbox").toggleClass("checked");
                    $(this).prev(".js-checkbox").find("input").click();
                }
            );

            filter.on("click", ".filter-tag-item", function () {
                removeFilterTag($(this), filter);
            });
        }
    }

    function docsFilterHandler(filter, itemContainer) {
        if (filter.length) {
            filter.on("click", ".category-item .item-button", function () {
                $(this).closest(".category-item").toggleClass("collapse");
            });

            itemContainer.on("click", function () {
                const id = $(this).attr("id");
                uncheckDocsCheckItems(id);
            });
        }
    }

    function renderModalFilterTags(filter) {
        renderFilterTags(filter, $(".modal-filters input:checkbox:checked"));
    }

    function renderListFilterTags(filter) {
        renderFilterTags(
            filter,
            $(".page-left-col .category-item input:checkbox:checked"),
            ".services-list-container"
        );
    }

    function renderFilterTags(filter, input, container = filter) {
        if (!filter.length) {
            return null;
        }

        $(".filter-tags", filter).html("");
        input.each(function () {
            let checkboxId = $(this).attr("id");
            let labels = $("label[for='" + checkboxId + "']");
            if (labels.length > 0) {
                $(".filter-tags", container).append(
                    "<div class='filter-tag-item' data-checkbox='" +
                        checkboxId +
                        "'>" +
                        labels[0].textContent +
                        "</div>"
                );
            }
        });
    }

    function removeFilterTag(elem, filter) {
        let input = $("#" + elem.attr("data-checkbox"), filter);
        input.closest(".js-checkbox").removeClass("checked");
        input.prop("checked", false);
        elem.remove();
    }

    function refreshFilter(filter) {
        const filterParams = getCategoriesFilterParams(filter) || {};
        const url = getFilterUrl(filterParams);
        if (url === "") {
            location.href = location.pathname;
        } else {
            location.href = location.pathname + "?" + url;
        }
    }

    function getCategoriesFilterParams(filter) {
        if (!filter.length) {
            return null;
        }

        // решил избавиться от длинных непонятных урлов

        // https://stackoverflow.com/questions/1829519/jquery-to-serialize-only-elements-within-a-div
        let serialized = $(":input", filter).serialize();
        if (!serialized) {
            return null;
        }

        // https://stackoverflow.com/questions/8648892/how-to-convert-url-parameters-to-a-javascript-object
        let params = JSON.parse(
            '{"' +
                decodeURI(serialized)
                    .replace(/"/g, '\\"')
                    .replace(/&/g, '","')
                    .replace(/=/g, '":"') +
                '"}'
        );
        if (!params) {
            return null;
        }

        let result = {};
        for (let key in params) {
            let name = key.split("[")[0];
            if (!result[name]) {
                result[name] = [];
            }
            result[name].push(params[key]);
        }

        return result;
    }

    function getFilterUrl(filterParams) {
        let filterUrl = serializeParams(filterParams) || "",
            sQuery = getSearchQuery() || "";

        if (sQuery === "") {
            return filterUrl;
        } else {
            if (filterUrl === "") {
                return sQuery;
            } else {
                return filterUrl + "&" + sQuery;
            }
        }
    }

    function serializeParams(filterParams) {
        let result = [];
        for (let name in filterParams) {
            result.push(name + "=" + filterParams[name].join(","));
        }

        return result.join("&");
    }

    function uncheckDocsCheckItems(id) {
        const checkbox = $("#" + id).closest(".item-checkbox");
        const mobileCheckbox = $(".filter-mobile")
            .find("#" + id)
            .closest(".item-checkbox");
        if (
            checkbox.hasClass("checked") ||
            mobileCheckbox.hasClass("checked")
        ) {
            checkbox.removeClass("checked");
            checkbox.find("input").removeAttr("checked");
            mobileCheckbox.removeClass("checked");
            mobileCheckbox.find("input").prop("checked", false);
            return refreshFilter(docsFilter);
        } else {
            return refreshFilter(docsFilter);
        }
    }
}

function headerPlate() {
    const servicesPlateBackground = $(
        ".services-page .page-header-plate .plate-background"
    );

    headerPlateHandler(servicesPlateBackground);

    const docsPlateBackground = $(
        ".docs-page .page-header-plate .plate-background"
    );
    headerPlateHandler(docsPlateBackground);

    function headerPlateHandler(plateBackground) {
        if (!plateBackground.length) {
            return null;
        }

        plateBackground.css(
            "right",
            "-" +
                ($(window).width() -
                    plateBackground.offset().left -
                    plateBackground.width()) +
                "px"
        );
    }
}

function subservicesActiveMenu() {
    var menuItems = $(".sidebar-menu .menu-list a"),
        contentItems = $(".subservice-item"),
        hh = $("#header").outerHeight(),
        wh = $(window).height(),
        body = $("html, body");

    if (!menuItems.length || !contentItems.length) {
        return null;
    }

    defineActiveMenu();

    $(window).on("scroll", function () {
        defineActiveMenu();
    });

    menuItems.on("click", function (e) {
        e.preventDefault();

        const activeContentItem = contentItems.filter(
            '[data-id="' + $(this).attr("data-id") + '"]'
        );
        if (activeContentItem.length) {
            body.stop().animate(
                { scrollTop: activeContentItem.offset().top - hh },
                500,
                "swing"
            );
        }
    });

    function defineActiveMenu() {
        var scrollTop = $(window).scrollTop(),
            top = scrollTop + wh / 2;
        menuItems.removeClass("active");
        contentItems.each(function () {
            var offset = $(this).offset().top;
            if (offset < top && offset + $(this).height() + 100 > top) {
                menuItems
                    .filter('[data-id="' + $(this).attr("data-id") + '"]')
                    .addClass("active");
            }
        });
    }
}

/* DEFINE IMAGES ORIENTATION */

function defineImagesOrientation(container) {
    $("img", container).each(function () {
        const img = $(this);
        if (img.height() > img.width()) {
            img.addClass("vertical");
        } else {
            img.addClass("horizontal");
        }
    });
}

/* STORIES */

function storiesPopupGallery() {
    const popup = $(".stories-popup");
    if (!popup.length) {
        return null;
    }

    let timeout, interval;

    const progressContainer = $(".popup-progress-container", popup);
    let progressLine = $(".container-line", progressContainer);

    const stories = $(".pub-stories-widget");
    if (stories) {
        stories.on("click", ".list-item", function (e) {
            e.preventDefault();
            openGallery($(this).attr("data-id"));
        });
    }

    popup.on("click", ".gallery-item", function () {
        showNextItem();
    });

    popup.on("click", ".popup-close-button", function () {
        closePopup();
    });

    function openGallery(itemId) {
        openPopup();
        showItem(itemId);
        runCounter();
    }

    function openPopup() {
        popup.addClass("open");
    }

    function closePopup() {
        popup.removeClass("open");
        clearTimeout(timeout);
        clearInterval(interval);
    }

    function showItem(id) {
        if (!id) {
            id = $(".gallery-item", popup).first().attr("data-id");
        }
        $(".gallery-item", popup).removeClass("active");
        $('.gallery-item[data-id="' + id + '"]', popup).addClass("active");

        $('.list-item[data-id="' + id + '"]').addClass("user-read");
        rememberUserRead(id);
    }

    function showNextItem() {
        const next = $(".gallery-item.active", popup).next();
        if (next.length) {
            showItem(next.attr("data-id"));
            runCounter();
        } else {
            closePopup();
        }
    }

    function runCounter() {
        if (timeout) {
            clearTimeout(timeout);
        }

        clearInterval(interval);
        resetProgressLine();
        let slideTimeout = 10000;
        let percentStep = (1000 / slideTimeout) * 100;
        let percent = percentStep;
        setTimeout(function () {
            // без таймаута все происходит мгновенно
            setProgressLine(percent);

            interval = setInterval(function () {
                percent += percentStep;
                if (percent >= 100) {
                    percent = 100;
                }
                setProgressLine(percent);

                if (percent >= 100) {
                    clearInterval(interval);
                }
            }, 1000);
        }, 1);

        timeout = setTimeout(function () {
            showNextItem();
        }, slideTimeout);
    }

    function resetProgressLine() {
        if (!progressLine) {
            return null;
        }

        setProgressLine(0);
        var htmlContent = progressContainer.html();
        progressContainer.html("");
        progressContainer.html(htmlContent);
        progressLine = $(".container-line", progressContainer);
    }

    function setProgressLine(percent) {
        if (!progressLine) {
            return null;
        }

        progressLine.css("width", percent + "%");
    }

    // запоминаем что пользователь посмотрел эту сторю
    function rememberUserRead(id) {
        let ids = localStorage.getItem("user-stories-read");
        if (ids) {
            ids = JSON.parse(ids);
        }
        if (!ids) {
            ids = [];
        }
        if (ids.indexOf(id) <= -1) {
            ids.push(id);
        }
        // чтоб не забивать память еще почистим старые
        if (ids.length >= 100) {
            ids.splice(0, 50);
        }
        localStorage.setItem("user-stories-read", JSON.stringify(ids));
    }
}

function markReadStories() {
    const stories = $(".pub-stories-widget .list-item");
    if (!stories.length) {
        return null;
    }

    let readIds = localStorage.getItem("user-stories-read");
    if (readIds) {
        readIds = JSON.parse(readIds);
    }
    if (!readIds || !readIds.length) {
        return null;
    }

    stories.each(function () {
        const story = $(this);
        if (readIds.indexOf(story.attr("data-id")) > -1) {
            story.addClass("user-read");
        }
    });
}

/* SCROLL FADING */
function initScrollFading() {
    var elements = $(".scroll-fading-container");

    elements.each(function () {
        var elem = $(this),
            detector = $(".scroll-fading-detector", elem);
        if (!detector.length) detector = elem;

        if (!elem.is(detector)) {
            var zIndex = detector.css("z-index");
            if (zIndex) elem.css("z-index", zIndex);
        }
    });
}

function checkScrollFading() {
    var elements = $(".scroll-fading-container"),
        defaultAppearOffset = 0,
        scrollTop = $(window).scrollTop(),
        windowHeight = $(window).height(),
        checkOffset = scrollTop + windowHeight,
        appearOffset;

    elements.each(function () {
        var elem = $(this),
            detector = $(".scroll-fading-detector", elem);
        if (!detector.length) detector = elem;
        appearOffset = parseInt(
            detector.attr("data-appear-offset") || defaultAppearOffset
        );
        if (checkOffset > detector.offset().top + appearOffset) {
            elem.addClass("visible");
        } else {
            elem.removeClass("visible");
        }
    });
}

/* PAGE SECTION GALLERY */

function pageSectionGallery() {
    let containers = $(".page-limiter").has(".list-rails"),
        sliding = false;
    containers.each(function () {
        var container = $(this);
        var rails = $(".list-rails", container);
        var contentWidth = rails[0].scrollWidth,
            containerWidth = rails.width();

        if (contentWidth <= containerWidth) {
            $(".button-next, .button-prev", container).hide();
            return null;
        } else {
            $(".button-next, .button-prev", container).show();
        }

        var listItemSample = $(".list-item-container:first", rails);
        if (!listItemSample.length) {
            listItemSample = $(".list-item:first", rails);
        }
        if (!listItemSample.length) {
            return null;
        }

        var scrollWidth = listItemSample.outerWidth(true);

        container.on("click", ".button-next", function () {
            if (!sliding) {
                sliding = true;
                var pos = parseInt(rails.css("left"));
                if (contentWidth + pos > containerWidth) {
                    rails.css("left", pos - scrollWidth + "px");
                }
                setTimeout(function () {
                    sliding = false;
                }, 400);
            }
        });

        container.on("click", ".button-prev", function () {
            if (!sliding) {
                sliding = true;
                var pos = parseInt(rails.css("left"));
                if (pos < 0) {
                    rails.css("left", pos + scrollWidth + "px");
                }
                setTimeout(function () {
                    sliding = false;
                }, 400);
            }
        });
    });
}

/* SELECT */

function selectInit(container) {
    container = container || $(document);

    $(".js-select", container).each(function () {
        refreshSelectButton($(this));
    });
}

function selectHandlers() {
    $(document).on("change", ".js-select select", function () {
        refreshSelectButton($(this).closest(".js-select"));
    });
}

function refreshSelectButton(selectContainer) {
    var selectedOption = $("select option:selected", selectContainer);
    var selectButton = $(".select-button", selectContainer);
    $(".button-text", selectButton).text(selectedOption.text());
}

/* LEFT COL PLATE */

function leftColPlate() {
    const plateBackground = $(".page-left-col .col-background");

    if (!plateBackground.length) {
        return null;
    }

    plateBackground.css("left", "-" + plateBackground.offset().left + "px");
}

function stickySidebar() {
    const sidebar = $(".page-left-col .sticky-block");
    if (!sidebar.length) {
        return false;
    }

    const initialOffsetTop = sidebar.offset().top + 20;
    const margin = 32;
    const stickyHeaderHeight = $("#header").height();

    positionSidebar();

    $(window).on("scroll resize", () => {
        positionSidebar();
    });

    function positionSidebar() {
        let scrolledHeaderOffset = $(window).scrollTop();
        const headerOffsetLimit = initialOffsetTop - stickyHeaderHeight;

        if (scrolledHeaderOffset > headerOffsetLimit) {
            scrolledHeaderOffset = headerOffsetLimit;
        }

        const offsetBottom =
            $(window).scrollTop() +
            initialOffsetTop -
            scrolledHeaderOffset +
            sidebar.outerHeight();
        const footerOffsetTop = $("#footer").offset().top;

        if (offsetBottom > footerOffsetTop) {
            sidebar.css("position", "absolute");
            sidebar.css("left", "0");
            sidebar.css(
                "top",
                footerOffsetTop -
                    sidebar.outerHeight() -
                    initialOffsetTop -
                    margin
            );
        } else {
            // сложно позиционировать фикседом, поэтому тут править надо будет, если что
            sidebar.css("position", "fixed");
            sidebar.css("left", `${sidebar.parent().offset().left}px`);
            sidebar.css("top", initialOffsetTop - scrolledHeaderOffset);
        }
    }
}

function stickyHeader() {
    var header = $("#header");

    positionHeader();

    $(window).on("scroll", function () {
        positionHeader();
    });

    function positionHeader() {
        if ($(window).scrollTop() > $(".header-bar", header).height()) {
            header.addClass("sticky");
        } else {
            header.removeClass("sticky");
        }
    }
}

function appointmentAgreement() {
    const checkbox = $(".agreement-check-item");
    const popup = $(".agreement-popup");
    const options = $(".appointment-options .options-item");

    if (checkbox.length) {
        checkbox.on("click", "label button", function () {
            popup.addClass("open");
        });

        popup.on("click", ".popup-close-button", function () {
            popup.removeClass("open");
        });

        options.on("click", function (e) {
            if (!$("input", checkbox).is(":checked")) {
                e.preventDefault();
                checkbox.addClass("error");
            }
        });

        checkbox.on("change", "input", function () {
            checkbox.removeClass("error");
        });
    }
}

function accordion() {
    $(document).on("click", ".accordion_header, .spoiler_header", function () {
        $(this).toggleClass("active");
        $(this)
            .parent()
            .find(".accordion_header-arrow, .spoiler_header-arrow")
            .toggleClass("animate");
        $(this)
            .parent()
            .find(".accordion_content, .spoiler_content")
            .slideToggle(280);
    });
}

function publicOffer() {
    const buttons = $(
        ".form-field.field-type-agreement label .agreement-open-js, .page-body .agreement-button"
    );
    const popup = $(".offer-popup");

    if (buttons.length) {
        buttons.on("click", function () {
            popup.addClass("open");
        });

        popup.on("click", ".popup-close-button", function () {
            popup.removeClass("open");
        });
    }
}

function formFloatingLabel(container) {
    const selector =
        ".form-field.field-type-text .form-control input, .form-field.field-type-email .form-control input, .form-field.field-type-textarea .form-control textarea";

    $(selector, container).each(function () {
        if ($(this).val()) {
            moveOverLabel($(this).closest(".form-field"));
        }
    });

    container.on("focusin", selector, function () {
        moveOverLabel($(this).closest(".form-field"));
    });
    container.on("focusout", selector, function () {
        moveInLabel($(this).closest(".form-field"));
    });

    function moveOverLabel(field) {
        $(".form-label", field).addClass("move-over");
    }

    function moveInLabel(field) {
        if (!$("input, textarea", field).val()) {
            $(".form-label", field).removeClass("move-over");
        }
    }
}

function formSearchField(container) {
    let searchTimeout;

    container.on("click", ".field-type-search .select-button", function () {
        revealResults($(this).closest(".form-field"));
    });

    container.on(
        "click",
        ".field-type-search .filter-dropdown .dropdown-item",
        function () {
            setFieldValue($(this));
            hideDropdown();
        }
    );

    container.on("input", ".field-type-search .input-control", function () {
        const field = $(this).closest(".form-field");
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
            $(".search-results", field).html("");
            searchResults(field, function () {
                revealResults(field);
            });
        }, 500);
    });

    $(document).on("click", function (e) {
        if (!$(".filter-container", container).has($(e.target)).length) {
            hideDropdown();
        }
    });

    function revealResults(field) {
        const dropdown = $(".filter-dropdown", field);
        $(".not-found-message", dropdown).hide();
        if (!$(".dropdown-item", dropdown).length) {
            $(".not-found-message", dropdown).show();
        }
        $(".filter-dropdown", field).show();
    }

    function hideDropdown(field) {
        if (field && field.length) {
            $(".filter-dropdown", field).hide();
        } else {
            // закрываем все
            $(".filter-dropdown", container).hide();
        }
    }

    function setFieldValue(dropdownItem) {
        const field = dropdownItem.closest(".form-field");
        $(".input-value", field).val(dropdownItem.attr("data-id"));
        $(".input-control", field).val(dropdownItem.text());
    }

    function searchResults(field, callback) {
        const searchInput = $(".input-control", field);
        const searchString = searchInput.val();
        if (!searchString) {
            return null;
        }

        $.ajax({
            url: searchInput.attr("data-url"),
            data: {
                searchString,
            },
            success: function (responseHtml) {
                $(".search-result", field).html(responseHtml);
                callback();
            },
            error: function () {
                callback();
            },
        });
    }
}

function getSearchQuery() {
    let sQuery = new URL(location.href).searchParams.get("squery");
    if (sQuery) {
        return "squery=" + sQuery;
    }
    return "";
}

function searchForm() {
    let searchForm = $(".search-form-js form"),
        sQuery = $(searchForm).find('[name="squery"]'),
        cancelButton = $(searchForm).find(".cancel-button");

    if (searchForm.length === 0 || sQuery.length === 0) {
        return false;
    }

    if (sQuery.val().length > 1) {
        $(cancelButton).fadeIn(300);
    } else {
        $(cancelButton).fadeOut(300);
    }

    searchForm.on("submit", function (e) {
        e.preventDefault();
        submitForm(getSearchUrl(sQuery.val()), null, false, false);
    });

    $(sQuery).on("keyup change", function (e) {
        e.preventDefault();
        if (sQuery.val().length > 1) {
            $(cancelButton).fadeIn(300);
        } else {
            $(cancelButton).fadeOut(300);
        }
    });

    $(cancelButton).on("click", function (e) {
        e.preventDefault();
        sQuery.val("");
        $(cancelButton).fadeOut(300);
    });

    function getSearchUrl(searchString) {
        let url = "",
            filterParams = "",
            urlQuery = document.location.search;

        if (urlQuery !== "") {
            urlQuery = urlQuery.replace("?&", "?");
            urlQuery = urlQuery.substr(1);
            if (urlQuery !== "?" && urlQuery !== "") {
                let params = JSON.parse(
                    '{"' +
                        decodeURI(urlQuery)
                            .replace(/"/g, '\\"')
                            .replace(/&/g, '","')
                            .replace(/=/g, '":"') +
                        '"}'
                );
                if (params) {
                    $.each(params, function (key, val) {
                        if (key !== "squery") {
                            appendToFilterParams(key, val);
                        }
                    });
                }
            }
        }

        function appendToFilterParams(key, val) {
            if (key !== "" || val !== "") {
                if (filterParams === "") {
                    filterParams = "?" + key + "=" + val;
                } else {
                    filterParams = filterParams + "&" + key + "=" + val;
                }
            }
        }

        if (filterParams) {
            url = location.pathname + filterParams + "&squery=" + searchString;
        } else {
            url = location.pathname + "?squery=" + searchString;
        }

        return url;
    }

    function submitForm(url, postData, isAjax, ajaxMethod) {
        if (url === "") {
            return false;
        }

        if (!ajaxMethod) {
            ajaxMethod = "GET";
        }

        if (!isAjax) {
            location.href = url;
        } else {
            // Делаем Ajax запрос
        }
    }
}

function siteChat() {
    let chatButton = $("#site-chat"),
        chatCloseButton = $("#site-chat-close"),
        chatBody = $("#site-chat-frame"),
        chatWidget = $("#site-chat-widget");

    if (chatButton.length === 0 || chatWidget.length === 0) {
        return false;
    }

    $(chatButton).click(function () {
        $(this).hide();
        if ($(window).width() < 425) {
            $(chatBody).css("width", $(window).width() + "px");
        }
        $(chatBody).attr("src", "https://bot.mfc66.ru");
        $(chatBody).on("load", function () {
            $(chatWidget).show();
        });
    });

    $(chatCloseButton).click(function (e) {
        e.preventDefault();
        $(chatButton).show();
        $(chatWidget).hide();
    });
}

function statusesDocumentsForm() {
    let SDFormWrap = $(".statuses-documents-form").first(),
        SDForm = $(SDFormWrap).find("form"),
        SDFormAction = $(SDForm).attr("action"),
        SDFormMethod = $(SDForm).attr("method"),
        cancelButtons = $(SDForm).find(".cancel-button"),
        SDFormInputs = $(SDForm).find(".input input"),
        SDFormSubmitBtn = $(SDForm).find(".submit-button");

    if (
        SDFormWrap.length === 0 ||
        SDForm.length === 0 ||
        SDFormInputs.length === 0
    ) {
        return false;
    }

    changeSubmitBtn();
    changeInputs(cancelButtons);

    SDForm.on("submit", function (e) {
        e.preventDefault();
        submitForm(
            SDFormAction,
            $(SDForm).serializeArray(),
            false,
            SDFormMethod
        );
    });

    $(cancelButtons).on("click", function (e) {
        e.preventDefault();
        $(this).closest(".input").find("input").val("");
        $(this).fadeOut(300);
        changeSubmitBtn();
    });

    $(SDFormInputs).on("keyup change", function (e) {
        e.preventDefault();
        let btn = $(this).closest(".input").find(".cancel-button");

        if ($(this).val().length > 1) {
            btn.fadeIn(300);
            changeSubmitBtn();
        } else {
            btn.fadeOut(300);
            changeSubmitBtn();
        }
    });

    $(SDFormSubmitBtn).on("click", function (e) {
        e.preventDefault();
        submitForm(SDFormAction, $(SDForm), false, SDFormMethod);
    });

    function changeSubmitBtn() {
        let quantityInput = SDFormInputs.length,
            filledInInput = 0;

        if (SDFormInputs.length > 0) {
            $.each(SDFormInputs, function (key, inp) {
                if ($(inp).val().length > 1) {
                    filledInInput++;
                }
            });
        }

        if (quantityInput === filledInInput) {
            SDFormSubmitBtn.removeAttr("disabled");
        } else {
            SDFormSubmitBtn.attr("disabled", "disabled");
        }
    }

    function changeInputs(btns) {
        if (!btns || btns.length === 0) {
            return false;
        }

        $.each(btns, function (key, btn) {
            if ($(btn).closest(".input").find("input").val().length > 1) {
                $(btn).fadeIn(300);
            } else {
                $(btn).fadeOut(300);
            }
        });
    }

    function submitForm(action, form, isAjax, ajaxMethod) {
        if ($(SDFormSubmitBtn).attr("disabled") || $(form).length === 0) {
            return false;
        }

        let url = location.pathname + action;

        if (!isAjax) {
            url = url + "?" + $(form).serialize();
            location.href = url;
        } else {
            // Делаем Ajax запрос
        }
    }

    $(".checking-readiness-documents-page").on(
        "click",
        ".default-page-container .modal .modal-close",
        function () {
            $(this).closest(".modal").fadeOut("fast");
        }
    );
}

function addElement(data) {
    if (!data) {
        return false;
    }

    if (!(data instanceof Object)) {
        return false;
    }

    $.each(data, function (el, datum) {
        if (datum.id === undefined || datum.id === "") {
            return false;
        }

        if ($("#" + datum.id).length !== 0) {
            return false;
        }

        let elClass = datum.class || "",
            elText = datum.text || "",
            elSrc = datum.src || "",
            elHref = datum.href || "",
            elAttributes = datum.attributes || "",
            element = "",
            position = datum.position || "append",
            target = datum.target || "body";

        if (el === "a") {
            element = $(
                "<" +
                    el +
                    ' href="' +
                    elHref +
                    '" id="' +
                    datum.id +
                    '" class="' +
                    elClass +
                    '" ' +
                    elAttributes +
                    " >" +
                    elText +
                    "</" +
                    el +
                    ">"
            );
        } else if (el === "img") {
            element = $(
                "<" +
                    el +
                    ' src="' +
                    elSrc +
                    '" id="' +
                    datum.id +
                    '" class="' +
                    elClass +
                    '" ' +
                    elAttributes +
                    " />"
            );
        } else if (el === "iframe") {
            element = $(
                "<" +
                    el +
                    ' src="' +
                    elSrc +
                    '" id="' +
                    datum.id +
                    '" class="' +
                    elClass +
                    '" ' +
                    elAttributes +
                    " >" +
                    elText +
                    "</" +
                    el +
                    ">"
            );
        } else {
            element = $(
                "<" +
                    el +
                    ' id="' +
                    datum.id +
                    '" class="' +
                    elClass +
                    '" ' +
                    elAttributes +
                    " >" +
                    elText +
                    "</" +
                    el +
                    ">"
            );
        }

        if (position === "after") {
            $(target).after(element);
        } else if (position === "before") {
            $(target).before(element);
        } else if (position === "prepend") {
            $(target).prepend(element);
        } else {
            $(target).append(element);
        }

        if (datum.children !== undefined && datum.children instanceof Array) {
            $.each(datum.children, function (i, child) {
                addElement(child);
            });
        }
    });
}

function deleteElement(target) {
    if ($(target).length > 0) {
        $(target).remove();
    }
}

function topButton() {
    let topBtn = {
        div: {
            id: "top-button",
            text: "",
            position: "append",
            target: "body",
            children: [
                {
                    div: {
                        id: "top-button-icon",
                        position: "append",
                        target: "#top-button",
                        class: "top-button-icon",
                    },
                },
            ],
        },
    };

    $(window).scroll(function () {
        let wTop = $(window).scrollTop();
        if (wTop >= 500) {
            addElement(topBtn);
            $("#top-button").addClass("active");
        } else {
            $("#top-button").removeClass("active");
        }
    });

    $(document).on("click", "#top-button", function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });
}

function imageBlock() {
    const imageBlock = $(".images-block");
    // const sliderContainer = $(".slider-container", imageBlock);
    // const previewList = $(".preview-list", imageBlock);

    // if (!imageBlock.length || !sliderContainer.length || !previewList.length) {
    //     return;
    // }

    $(imageBlock).each(function (index) {
        const sliderContainer = $(".slider-container", this);
        const previewList = $(".preview-list", this);

        if (!sliderContainer.length || !previewList.length) {
            return;
        }

        draggableHorizontalScroll(previewList[0]);

        let activePreview = $(".preview.active", previewList);
        if (!activePreview.length) {
            activePreview = $(".preview", previewList).first();
            activePreview.addClass("active");
            const activeImageSrc = activePreview.data("src");
            $(".slider-content .current-image", sliderContainer).css(
                "background-image",
                'url("' + activeImageSrc + '")'
            );
            $(".nav-button.prev", sliderContainer).addClass("disabled");
            if ($(".preview", previewList).length === 1) {
                $(".nav-button.next", sliderContainer).addClass("disabled");
            }
        }

        $(".preview", previewList).on("click", function (e) {
            let element = $(e.target);
            if (!element.hasClass("preview")) {
                element = element.closest(".preview");
            }

            // если элемент активный ничего делать не нужно
            if (element.hasClass("active")) {
                return;
            }

            $(".preview.active", previewList).removeClass("active") &&
                element.addClass("active");
            const imageSrc = element.data("src");
            $(".slider-content .current-image", sliderContainer).css(
                "background-image",
                'url("' + imageSrc + '")'
            );

            const elementIndex = element.index();
            const previewCount = $(".preview", previewList).length;
            checkNavButton(sliderContainer, elementIndex, previewCount);
        });

        $(".nav-button", sliderContainer).on("click", function (e) {
            let element = $(e.target);
            if (!element.hasClass("nav-button")) {
                element = element.closest(".nav-button");
            }

            // если кнопка не активна ничего делать не нужно
            if (element.hasClass("disabled")) {
                return;
            }

            const currentImage = $(
                ".slider-content .current-image",
                sliderContainer
            );
            $(".nav-button.disabled", sliderContainer).removeClass("disabled");

            if (element.hasClass("prev")) {
                const activePreview = $(".preview.active", previewList);
                const prevPreview = activePreview.prev();
                if (!prevPreview.length) {
                    element.addClass("disabled");
                    return;
                }

                const prevPreviewSrc = prevPreview.data("src");
                currentImage.css(
                    "background-image",
                    'url("' + prevPreviewSrc + '")'
                );
                activePreview.removeClass("active") &&
                    prevPreview.addClass("active");

                const prevPreviewIndex = prevPreview.index();
                const previewCount = $(".preview", previewList).length;
                checkNavButton(sliderContainer, prevPreviewIndex, previewCount);
            }

            if (element.hasClass("next")) {
                const activePreview = $(".preview.active", previewList);
                const nextPreview = activePreview.next();
                if (!nextPreview.length) {
                    element.addClass("disabled");
                    return;
                }

                const nextPreviewSrc = nextPreview.data("src");
                currentImage.css(
                    "background-image",
                    'url("' + nextPreviewSrc + '")'
                );
                activePreview.removeClass("active") &&
                    nextPreview.addClass("active");

                const nextPreviewIndex = nextPreview.index();
                const previewCount = $(".preview", previewList).length;
                checkNavButton(sliderContainer, nextPreviewIndex, previewCount);
            }
        });
    });

    function checkNavButton(sliderContainer, previewIndex, previewCount) {
        $(".nav-button.disabled", sliderContainer).removeClass("disabled");
        if (previewIndex === 0) {
            $(".nav-button.prev", sliderContainer).addClass("disabled");
        }
        if (previewIndex === previewCount - 1) {
            $(".nav-button.next", sliderContainer).addClass("disabled");
        }
    }
}

function draggableHorizontalScroll(container) {
    if (!container) {
        return;
    }

    let isDown = false;
    let startX;
    let scrollLeft;

    container.addEventListener("mousedown", (e) => {
        isDown = true;
        container.classList.add("active");
        startX = e.pageX - container.offsetLeft;
        scrollLeft = container.scrollLeft;
    });
    container.addEventListener("mouseleave", () => {
        isDown = false;
        container.classList.remove("active");
    });
    container.addEventListener("mouseup", () => {
        isDown = false;
        container.classList.remove("active");
    });
    container.addEventListener("mousemove", (e) => {
        if (!isDown) {
            return;
        }
        e.preventDefault();
        const x = e.pageX - container.offsetLeft;
        const walk = (x - startX) * 2; //scroll-fast
        container.scrollLeft = scrollLeft - walk;
    });
}

function buildMunicipalities() {
    if (!$(".widget-municipalities-data").text()) {
        return null;
    }

    let municipalitiesContainer = $(".municipalities-container"),
        containerTabs = $(municipalitiesContainer).find(".tabs"),
        containerTabsData = $(municipalitiesContainer).find(".tabs-data"),
        municipalitiesData = JSON.parse(
            $(".widget-municipalities-data").text()
        ),
        allOffices = JSON.parse(municipalitiesData.allOffices || []);

    if (
        !municipalitiesData ||
        !municipalitiesData.municipalities ||
        !(municipalitiesData.municipalities instanceof Array)
    ) {
        return null;
    }

    let allOfficesDataContainer = $(containerTabsData).find("#data-0");

    $(allOfficesDataContainer).fadeOut(0);

    if (eachOffices(allOffices, allOfficesDataContainer)) {
        $(allOfficesDataContainer).fadeIn(300);
        if (eachMunicipalities()) {
            $(containerTabs).find(".tab-item").fadeIn(300);
        }
    }

    function eachOffices(offices, container) {
        let firstLetter;
        let item;
        $.each(offices, function (i, office) {
            if (office.firstLetter) {
                if (office.firstLetter !== firstLetter) {
                    firstLetter = office.firstLetter;
                    item =
                        '<a href="' +
                        location.href +
                        "/item?id=" +
                        office.id +
                        '">' +
                        '<div data-id="' +
                        office.id +
                        '" class="tabs-data-item"><span class="city-first-letter">' +
                        firstLetter +
                        '</span><span class="city-bold">' +
                        office.city +
                        "</span>" +
                        office.street +
                        "</div></a>";
                } else {
                    item =
                        '<a href="' +
                        location.href +
                        "/item?id=" +
                        office.id +
                        '">' +
                        '<div data-id="' +
                        office.id +
                        '" class="tabs-data-item"><span class="city-bold">' +
                        office.city +
                        "</span>" +
                        office.street +
                        "</div></a>";
                }
            }
            $(container).append(item);
        });
        return true;
    }

    function eachMunicipalities() {
        $.each(municipalitiesData.municipalities, function (i, municipality) {
            let itemData =
                    '<div id="data-' +
                    municipality.id +
                    '" class="tabs-data-body" data-tab-data-id="' +
                    municipality.id +
                    '" style="display: none;"></div>',
                offices = JSON.parse(municipality.offices || []);
            $(containerTabsData).append(itemData);
            if (offices.length !== 0) {
                eachOffices(offices, $("#data-" + municipality.id));
            }
        });
        return true;
    }

    $(document).on("click", ".tabs .tab-item", function () {
        let thisTab = $(this),
            thisData = $(".municipalities-container .tabs-data").find(
                "#" + $(thisTab).attr("data-tab-id")
            );

        $(".municipalities-container .tabs .tab-item").removeClass("active");
        $(".municipalities-container .tabs-data .tabs-data-body").hide();
        $(thisTab).addClass("active");
        $(thisData).fadeIn(300);
    });
}

// переключение табов
function tabsInit() {
    $(".tabs-item-js").on("click", function (e) {
        $(".tabs-item-js").removeClass("active");
        let currentElement = $(e.currentTarget);
        currentElement.addClass("active");
        $(".tabs--content-js").removeClass("active");
        let idTab = currentElement.data("tab");
        $(`#${idTab}`).addClass("active");
        let url = `${window.location.pathname}${window.location.search}`;

        let currentPage = currentElement.attr("data-current-page"); //получаю номер последней открытой страницы у активного таба

        // если в таб ранее контент уже был загружен, то ajax не отправляем
        if ($(`#${idTab}`).children().length) {
            return false;
        }

        $.ajax({
            url: `${url}&page=${currentPage}`,
            data: {
                type: idTab,
            },
            success: function (responseHtml) {
                $(`#${idTab}`).html($(responseHtml).find(`#${idTab}`).html());
            },
        });
    });
}

// клик по пагинации
function tabsPaginations() {
    $(document).on("click", ".tabs--content-js .pagination a", function (e) {
        e.preventDefault();
        let currentElement = $(e.currentTarget);
        let url = currentElement.attr("href");
        let idTab = $(".tabs-item-js.active").data("tab");
        let numPage = url.split("page=").pop();

        $.ajax({
            url: url,
            data: {
                type: idTab,
            },
            success: function (responseHtml) {
                $(`#${idTab}`).html($(responseHtml).find(`#${idTab}`).html());
                // запоминаю номер последней открытой старницы у таба
                $(".tabs-item-js.active").attr("data-current-page", numPage);
            },
        });
    });
}

function informationModal() {
    $(document).on("click", ".information.modal .modal-close", function () {
        $(this).closest(".information.modal").fadeOut("fast");
    });
}

/* PersonalDataProcessingWidget */
function personalDataProcessingWidget() {
    const widget = $(".personal-data-processing-widget");
    const cookieName = widget.data("cookie-name");

    if (!cookieName) {
        return false;
    }

    // @note на самом деле, этот кусок кода, наверное, можно убрать
    const value = $.cookie(cookieName);
    const adminPanel = $("#admin-panel");

    if (
        !value ||
        (adminPanel.length && location.pathname == "/" && !location.search)
    ) {
        widget.show();
    }
    const acceptanceButton = widget.find(".widget-button button");
    const agreementButtons = $(
        ".personal-data-processing-widget .agreement-popup-button, #footer-bottom .copyrights .agreement-popup-button"
    );
    const agreementPopup = $(".personal-data-processing-popup");
    const date = new Date();

    acceptanceButton.on("click", () => {
        // @note отказался от jquery.cookie.js ибо там какие-то проблемы с подгрузкой плагина в кабинете админа
        date.setDate(date.getDate() + 30);
        document.cookie = [
            cookieName,
            "=",
            encodeURIComponent(true),
            "; expires=",
            date.toUTCString(),
            "; path=",
            "/",
        ].join("");

        widget.hide();
    });

    agreementButtons.on("click", function (e) {
        e.preventDefault();
        agreementPopup.addClass("open");
    });

    agreementPopup.on("click", ".popup-close-button", function (e) {
        e.preventDefault();
        agreementPopup.removeClass("open");
    });
}

/* Management dropdown */

function departmentDropdown() {
    plateDropdown(".department-button", ".department-plate");
}

function plateDropdown(button, plate) {
    $(document).on("click", button, function () {
        $(this).closest(plate).toggleClass("collapse");
    });
}

/* Cabinet List dropdown */

function cabinetListDropdown() {
    plateDropdown(".cabinet-plate-button", ".cabinet-plate");
}

/* Filesloader */

function filesLoaderButton() {
    $("#upload").on("change", function () {
        $(".file-chosen").text("");
        for (let i = 0; i < this.files.length; i++) {
            $(
                '<span class= "file-chosen">' + this.files[i].name + "</span>"
            ).appendTo(".field-name-file .form-control .chosen-container");
        }
    });
}

/* Form */

function formHandler() {
    const treatmentForm = $(".validatable-form");
    const refusalButton = $("#refusal-button");

    if (!treatmentForm || !refusalButton) {
        return false;
    }

    $(".cabinet-spec-order-page .validatable-form .form-button").attr(
        "disabled",
        ""
    );
    let message = {};
    const inputs = $(".validatable-form :input");

    inputs.blur((e) => {
        if (!isValid($(e.target), message)) {
            applyInvalidInput($(e.target), message);
        } else {
            applyPlainInput($(e.target));
        }
    });

    $(".field-name-get-answer-email input").change((e) => {
        if (e.currentTarget.checked) {
            enableEmail();
        } else {
            disableEmail();
        }
    });

    $(".field-name-get-answer-post input").change((e) => {
        if (e.currentTarget.checked) {
            enableAddress();
        } else {
            disableAddress();
        }
    });

    treatmentForm.change(() => {
        if (isFormValid()) {
            enableButtons();
        } else {
            disableButtons();
        }
    });

    $(".cabinet-feedback form").submit(function (e) {
        e.preventDefault();
        disableButtons();
        $.ajax({
            url: $(this).attr("action"),
            data: new FormData(this),
            contentType: false,
            processData: false,
            type: $(this).attr("method"),
            success: function (data) {
                enableButtons();
                let response = JSON.parse(data);
                if (
                    response.fieldsErrors &&
                    !jQuery.isEmptyObject(response.fieldsErrors) &&
                    response.fieldsErrors.length !== 0
                ) {
                    showFieldsErrors(response.fieldsErrors);
                    if (response.errors && response.errors.length) {
                        showError(response.errors);
                    }
                } else if (
                    response.errors &&
                    response.errors.length &&
                    response.treatmentIdMessage
                ) {
                    showModal(response.errors, response.treatmentIdMessage);
                } else if (response.success) {
                    showModal(response.success);
                }
            },
            error: function () {
                callback();
            },
        });
    });

    refusalButton.click(function (e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr("href"),
            contentType: false,
            success: function (data) {
                let response = JSON.parse(data);
                if (
                    response.errors &&
                    response.errors.length &&
                    response.treatmentIdMessage
                ) {
                    showModal(response.errors, response.treatmentIdMessage);
                } else if (response.success) {
                    showModal(response.success);
                }
            },
            error: function () {
                callback();
            },
        });
    });

    $(document).on(
        "click",
        ".cabinet-spec-order-page .modal .cross-icon",
        function () {
            $(this).closest(".cabinet-spec-order-page .modal").fadeOut("fast");
        }
    );

    function isFormValid() {
        let allValid = true;
        if (
            $(".field-name-get-answer-email input").length &&
            !$(".field-name-get-answer-email input").is(":checked") &&
            !$(".field-name-get-answer-post input").is(":checked")
        ) {
            allValid = false;
        }
        inputs.each((i, input) => {
            if ($(input).attr("required") && !isValid($(input), message)) {
                allValid = false;
            }
        });

        return allValid;
    }

    function isValid(element, message) {
        let validationMessages = JSON.parse(
            treatmentForm.attr("data-messages")
        );
        if (element.attr("name") === "agreement") {
            if (!element.is(":checked")) {
                message[element.attr("name")] = validationMessages.agreement;
                return false;
            }
            return true;
        }

        if (element.attr("type") === "select-one") {
            return true;
        }

        if (element.val() === "" && element.attr("required")) {
            message[element.attr("name")] = validationMessages.required;
            return false;
        }

        return true;
    }

    function applyInvalidInput(element, message) {
        element.closest(".form-field").addClass("invalid").removeClass("valid");
        let span = element.closest(".form-field").find(".input-message");
        if (Array.isArray(message[element.attr("name")])) {
            $.each(message[element.attr("name")], (i) => {
                span.html(
                    "<span>" + message[element.attr("name")][i] + "</span>"
                );
            });
        } else {
            span.html("<span>" + message[element.attr("name")] + "</span>");
        }
    }

    function applyPlainInput(element) {
        element.closest(".form-field").removeClass("invalid valid");
        element.closest(".form-field").find(".input-message").text("");
    }

    function enableEmail() {
        $(".field-name-email input").attr("required", "");
        $(".field-name-email").show();
    }

    function disableEmail() {
        $(".field-name-email input").removeAttr("required").val("");
        $(".field-name-email").hide();
    }

    function enableAddress() {
        addressFieldsRequired();
        $(".validatable-form").toggleClass("show-address");
    }

    function disableAddress() {
        $("div[class*='field-name-address-'] input")
            .removeAttr("required")
            .val("");
        $(".validatable-form").toggleClass("show-address");
    }

    function addressFieldsRequired() {
        $(".field-name-address-index input").attr("required", "");
        $(".field-name-address-city input").attr("required", "");
        $(".field-name-address-street input").attr("required", "");
        $(".field-name-address-house input").attr("required", "");
    }

    function showFieldsErrors(fieldsErrors) {
        inputs.each((i, input) => {
            if ($(input).attr("name") in fieldsErrors) {
                input.scrollIntoView();
                applyInvalidInput($(input), fieldsErrors);
            }
        });
    }

    function showError(errors) {
        $("html, body").animate({ scrollTop: 0 }, 600);
        $(".page-body p").hide();
        $(".page-body").addClass("errors");
        $.each(errors, (i) => {
            $(".page-body").html("<div>" + errors[i] + "</div>");
        });
    }

    function showModal(caption, id = undefined) {
        let modal = $(".cabinet-spec-order-page .modal");
        modal.css("display", "flex");
        if (id) {
            $.each(caption, (i) => {
                $(modal).find(".modal-header").append(caption[i]);
                $(modal).find(".modal-body").append(id);
            });
        } else {
            $(modal).find(".modal-header").append(caption);
        }
    }

    function enableButtons() {
        $(".validatable-form .form-button").removeAttr("disabled");
    }

    function disableButtons() {
        $(".validatable-form .form-button").attr("disabled", "");
    }
}

/* filter mobile */

function filterMobile() {
    $(".filter-mobile-header").on("click", function () {
        $(".filter-mobile").toggleClass("hidden");
    });
}

/* notify button */

function notifyButtonHandler() {
    const notifyButton = $("#notify-bell");
    notifyButton.click(function (e) {
        e.preventDefault();
        $(this).closest(".button-notification").toggleClass("active");
        $.ajax({
            url: $(this).attr("href"),
            contentType: false,
            success: function (data) {
                let response = JSON.parse(data);
                if (!response.errors.length && response.success) {
                    $(".notifications-count", notifyButton).hide();
                }
            },
            error: function () {
                callback();
            },
        });
    });
}

function fixIndexFeedbackHeight() {
    const parent = document.querySelector(".feedback-widget");
    if (!parent) return;

    const cards = parent.querySelectorAll(".feedback-content");
    if (cards.length == 0) return;

    var maxHeight = 0;
    for (let card of cards) {
        $(card).removeAttr("style");
        maxHeight = Math.max(maxHeight, $(card).height());
    }

    for (let card of cards) {
        $(card).height(maxHeight);
    }
}

function shareButtonClick() {
    const shareButton = document.querySelector(".news-detail--share");
    if (!shareButton) {
        return;
    }

    shareButton.addEventListener("click", (event) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(shareButton.dataset.url);
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = shareButton.dataset.url;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand("copy");
            } catch (err) {
                console.error("Unable to copy to clipboard", err);
            }
            document.body.removeChild(textArea);
        }

        const popup = $(".copy-clipboard-popup");
        popup.addClass("open");

        popup.on("click", ".cross-icon", function () {
            popup.removeClass("open");
        });
    });
}

/* TRASH */
function registerTrash() {
    // TODO: посмотреть что здесь не так
    const dropdownSection = $("#trash-section-dropdown");
    const dropdownCategory = $("#trash-category-dropdown");
    const sectionCategories = ["sections"];

    if (!dropdownSection) {
        return;
    }

    if (!dropdownSection.length) {
        return true;
    }

    checkSections();

    $(document).on(
        "click",
        ".trash-section-selection .dropdown-button",
        function () {
            $(this).toggleClass("active-state");
            dropdownSection.toggleClass("active-state");
        }
    );

    $(document).on(
        "click",
        ".trash-section-selection .dropdown-content .dropdown-option",
        () => {
            dropdownSection.removeClass("active-state");
            $(".trash-section-selection .dropdown-button").removeClass(
                "active-state"
            );
        }
    );

    $(document).on(
        "click",
        ".trash-section-selection .dropdown-option",
        function () {
            $(
                ".trash-section-selection .dropdown-button .dropdown-caption"
            ).text($(this).find(".dropdown-caption").text());
            $("#trash-section").val($(this).attr("data-value"));
            // dropdownSection.hide();
        }
    );

    $(document).on(
        "click",
        ".trash-category-selection .dropdown-button",
        function () {
            $(this).toggleClass("active-state");
            dropdownCategory.toggleClass("active-state");
        }
    );

    $(document).on(
        "click",
        ".trash-category-selection .dropdown-content .dropdown-option",
        () => {
            dropdownCategory.removeClass("active-state");
            $(".trash-category-selection .dropdown-button").removeClass(
                "active-state"
            );
        }
    );

    $(document).on(
        "click",
        ".trash-category-selection .dropdown-option",
        function () {
            $(
                ".trash-category-selection .dropdown-button .dropdown-caption"
            ).text($(this).find(".dropdown-caption").text());
            $("#trash-category").val($(this).attr("data-value"));
            $("#trash-category").trigger("change");
            // dropdownCategory.hide();
        }
    );

    $(document).on("change", "#trash-category", () => {
        checkSections();
    });

    $(document).on("click", ".trash-basket .pager-btn", function (event) {
        event.preventDefault();
        $("li.pager-item.active").removeClass("active");
        $(this).closest(".pager-item").addClass("active");
        $.ajax({
            url: $(this).attr("href"),
            data: $(".trash-send-data").serialize(),
            type: "POST",
            success(response) {
                $(this).closest(".trash-lists-block").html(response);
            },
        });
    });
    $(".trash-send-data").bind("keydown", (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
        }
    });

    function checkSections() {
        const activeCategory = $("#trash-category").val();
        const sectionsSelect = $(".trash-section-selection");

        if (sectionCategories.indexOf(activeCategory) == -1) {
            $("#trash-section").val("");
        }

        if (sectionCategories.indexOf(activeCategory) > -1) {
            sectionsSelect.show();
        } else {
            sectionsSelect.hide();
        }
    }
}

/**/
function phoneContactsShow() {
    const orgPhoneContacts = $(".org-phone-contacts");

    orgPhoneContacts.on("click", ".circle-arrow", function () {
        $(this).closest(".circle-arrow").toggleClass("active");
        orgPhoneContacts.find(".phones-popup").toggleClass("visible");
    });

    orgPhoneContacts.on("click", ".popup-close-button", function () {
        orgPhoneContacts.find(".phones-popup").toggleClass("visible");
        orgPhoneContacts.find(".circle-arrow").toggleClass("active");
    });
}

